import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { clampGroundCast, isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createAnnie(id = 'annie-1', team = 'blue', x = 300, y = 1300) {
  const annie = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 528,
    maxMp: 334,
    ad: 50,
    ap: 0,
    armor: 27,
    mr: 30,
    ms: 335,
    attackRange: 625,
    attackSpeed: 0.579,
    name: 'Annie',
    radius: 20
  });
  annie.moltenShieldActive = false;
  return annie;
}

export function castAnnieQ(caster, target) {
  if (!target || target.isDead || caster.mp < 60) return false;
  if (!isWithinAbilityRange(caster, target, 625, caster)) return false;
  caster.mp -= 60;
  const damage = 75 + (caster.ap || 0) * 0.8;
  target.takeDamage(damage, caster, 'magic');
  if (target.isDead && target.statusManager?.addEffect) {
    target.statusManager.addEffect(EFFECT_TYPES.STUN, 1.25, 0, target.tenacity || 0);
  }
  return true;
}

export function castAnnieW(caster, targetX, targetY, projectiles, gameTime) {
  if (caster.mp < 70) return false;
  caster.mp -= 70;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 70 + (caster.ap || 0) * 0.85;
  const spread = 0.55;
  const start = angle - spread / 2;
  for (let i = 0; i < 5; i++) {
    const a = start + (spread / 4) * i;
    projectiles.push({
      id: `annie-w-${caster.id}-${gameTime}-${i}`,
      casterId: caster.id,
      team: caster.team,
      x: caster.x,
      y: caster.y,
      vx: Math.cos(a) * 1100,
      vy: Math.sin(a) * 1100,
      range: 600,
      traveled: 0,
      damage,
      damageType: 'magic',
      radius: 14
    });
  }
  return true;
}

export function castAnnieE(caster) {
  if (!caster || caster.isDead || caster.mp < 60) return false;
  caster.mp -= 60;
  caster.moltenShieldActive = true;
  caster.armor = (caster.armor || 0) + 20;
  caster.mr = (caster.mr || 0) + 20;
  return true;
}

export function castAnnieR(caster, x, y, entities = []) {
  if (caster.mp < 100) return false;
  caster.mp -= 100;
  const aim = clampGroundCast(caster, x, y, 600);
  const damage = 185 + (caster.ap || 0) * 0.7;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, aim.x, aim.y, 250, caster)) continue;
    e.takeDamage(damage, caster, 'magic');
    if (e.statusManager?.addEffect) {
      e.statusManager.addEffect(EFFECT_TYPES.STUN, 1.0, 0, e.tenacity || 0);
    }
  }
  return true;
}
